import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CurrencyFormatPipe } from "./currency-format.pipe";
import { PhoneNumberPipe } from "./phone-number.pipe";
import { SafePipe } from "./safe.pipe";
import { FormatPipe } from "./format.pipe";
import { OperatorPipe } from "./operator.pipe";
import { SplitPipe } from "./split.pipe";
import { AccountFormatPipe } from "./account.pipe";
import { RoundPipe } from "./round.pipe";
import { ParseDatePipe } from "./parse-date.pipe";
import { ClabePipe } from "./clabe.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { ShortNumberPipe } from "./short-number.pipe";
import { SumPipe } from "./sum.pipe";
import { MaxPipe } from "./max.pipe";
import { MinPipe } from "./min.pipe";
import { PhoneHideDigitsPipe } from "./phone-hide-digits.pipe";
import { AddTimePipe } from "./add-time.pipe";
import { GetInitialsPipe } from "./get-initials.pipe";
import { CapitalizePipe } from "./capitalize.pipe";
import { OrderByPipe } from "./order-by.pipe";
import { MexicanPhonePipe } from "./mexican-phone.pipe";
import { ReferenceRelationshipLabelPipe } from "./reference-relationship-label.pipe";
import { TimeToWordsPipe } from "./time-to-words.pipe";

@NgModule({
  declarations: [
    CurrencyFormatPipe,
    PhoneNumberPipe,
    SafePipe,
    FormatPipe,
    OperatorPipe,
    SplitPipe,
    AccountFormatPipe,
    RoundPipe,
    ParseDatePipe,
    ClabePipe,
    TruncatePipe,
    ShortNumberPipe,
    SumPipe,
    MaxPipe,
    MinPipe,
    PhoneHideDigitsPipe,
    AddTimePipe,
    GetInitialsPipe,
    CapitalizePipe,
    OrderByPipe,
    MexicanPhonePipe,
    ReferenceRelationshipLabelPipe,
    TimeToWordsPipe,
  ],
  imports: [CommonModule],
  providers: [
    CurrencyFormatPipe,
    PhoneNumberPipe,
    SafePipe,
    FormatPipe,
    OperatorPipe,
    SplitPipe,
    AccountFormatPipe,
    RoundPipe,
    ParseDatePipe,
    ClabePipe,
    TruncatePipe,
    ShortNumberPipe,
    SumPipe,
    MaxPipe,
    MinPipe,
    PhoneHideDigitsPipe,
    AddTimePipe,
    GetInitialsPipe,
    CapitalizePipe,
    OrderByPipe,
    MexicanPhonePipe,
    ReferenceRelationshipLabelPipe,
    TimeToWordsPipe,
  ],
  exports: [
    CurrencyFormatPipe,
    PhoneNumberPipe,
    SafePipe,
    FormatPipe,
    OperatorPipe,
    SplitPipe,
    AccountFormatPipe,
    RoundPipe,
    ParseDatePipe,
    ClabePipe,
    TruncatePipe,
    ShortNumberPipe,
    SumPipe,
    MaxPipe,
    MinPipe,
    PhoneHideDigitsPipe,
    AddTimePipe,
    GetInitialsPipe,
    CapitalizePipe,
    OrderByPipe,
    MexicanPhonePipe,
    ReferenceRelationshipLabelPipe,
    TimeToWordsPipe,
  ],
})
export class PipeModule {}
